import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'dp-world-sidebar',
  templateUrl: './dp-world-sidebar.component.html',
  styleUrls: ['./dp-world-sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None
})

/**
 * Shared sidebar component used in project template.
 * This is library code, do no edit this!
 */
export class DpWorldSidebarComponent implements OnInit {

  @Input() content: Array<any>;
  @Input() logo: any = {};
  @Input() isDev: boolean = false;
  @Input() isBeta: boolean = false;

  // when clicking the logo at the top, this is the route it will navigate to.
  @Input() logoRoute: string = '';

  homeRoute = null;

  public open = false;
  private focusIn = false;
  private mouseIn = false;

  constructor(private router: Router,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    this.homeRoute = {
      route: this.logoRoute
    };
    this.content.forEach((iconInstance) => {
      if (iconInstance.icon.includes('.svg')) {
        const iconName = this.getSvgIconFromPath(iconInstance.icon);
        iconInstance['svgIcon'] = iconName;
        this.iconRegistry.addSvgIcon(
          iconName,
          this.sanitizer.bypassSecurityTrustResourceUrl(iconInstance.icon));
      }
    });
  }

  public onFocusIn(): void {
    this.focusIn = true;
    this.open = true;
  }

  public onFocusOut(): void {
    this.focusIn = false;
    if (!this.mouseIn) {
      this.open = false;
    }
  }

  public onMouseEnter(): void {
    this.mouseIn = true;
    this.open = true;
  }

  public onMouseLeave(): void {
    this.mouseIn = false;
    if (!this.mouseIn) {
      this.open = false;
    }
  }

  navigateTo(item: any) {
    this.router.navigate([item.route], { queryParams: item.queryParams });
  }

  getSvgIconFromPath(svgPath: string): string {
    const splitIconPath = svgPath.split('/');
    const svgName = splitIconPath[splitIconPath.length - 1];
    const iconName = svgName.split('.')[0];
    return iconName;
  }
}